import { Injectable } from '@angular/core';
import { Client, Message } from '@stomp/stompjs';
import { CookieService } from 'ngx-cookie-service';
import SockJS from 'sockjs-client/dist/sockjs.min.js';
import { environment } from 'environments/environment';
import { NotificationsService } from 'app/layout/components-common/notifications/notifications.service';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';

@Injectable({ providedIn: 'root' })
export class WebSocketService {
  private stompClient: Client | null = null;
  private connected = false;
  private alreadySubscribed = false;

  constructor(
    private _notificationsService: NotificationsService,
    private _mStorage: manageStorageService,
    private _cookieService: CookieService
  ) { }

  contrato: string = this._mStorage.getPropertie('s_userSession')?.uuid;
  usuario: string = this._mStorage.getPropertie('s_userSession')?.principal;

  /**
   * !connect
   * process conect webSocket
   * @returns 
   */
  connect(): void {
    if (this.connected || this.stompClient?.active) return;

    const usuario = this._mStorage.getPropertie('s_userSession')?.principal;
    const sessionId = this._mStorage.getPropertie('s_xsid');

    if (!usuario || !sessionId) { console.error('⚠️ Usuario o sessionId no encontrados en el almacenamiento'); return; }

    const socket = new SockJS(
      `${environment.ipServer}${environment.websocketUrl}?usuario=${usuario}&sessionId=${sessionId}`, null, {
      transports: ['xhr-streaming', 'xhr-polling']
    }
    );

    this.stompClient = new Client({
      webSocketFactory: () => socket,
      debug: () => { },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => {
        this.connected = true;
        // console.log('%c🟢 WebSocket conectado', 'color: green');
      },
      onStompError: (frame) => {
        console.warn('⚠️ STOMP Error', frame.headers['message'], frame.body);
        console.error('❌ STOMP Error', frame.headers['message'], frame.body);
      },
    });

    this.stompClient.activate();
  }

  /**
   * subscribe to the topic
   * @param userId 
   * @param callback 
   * @returns 
   */
  subscribeToUserAlerts(userId: string, callback: (msg: string) => void): void {
   if (this.alreadySubscribed) return;

    if (this.stompClient?.connected) {
      this.stompClient.subscribe(
        `/topic/alerta/${userId}`,
        (message: Message) => {
          const alertData = JSON.parse(message.body);
          this._notificationsService.addNotificationFromWebSocket(alertData);

          callback(message.body);
        }
      );
      this.alreadySubscribed = true;
    } else {
      setTimeout(() => this.subscribeToUserAlerts(userId, callback), 1000);
    }
  }

  /**
   * verfiy if webSocket is conected
   * @returns 
   */
  isConnected(): boolean {
    return this.connected;
  }

  /**
   * !disconnect
   * disconnect webSocket client 
   */
  disconnect(): void {
    this.stompClient?.deactivate();
    this.connected = false;
    this.alreadySubscribed = false;
    // console.log('%c🔴 WebSocket desconectado', 'color: red');
  }
}
